import { render } from "./OfficeDicision.vue?vue&type=template&id=7eb3174e&scoped=true"
import script from "./OfficeDicision.vue?vue&type=script&lang=js"
export * from "./OfficeDicision.vue?vue&type=script&lang=js"

import "./OfficeDicision.vue?vue&type=style&index=0&id=7eb3174e&lang=scss&scoped=true"
import "./OfficeDicision.vue?vue&type=style&index=1&id=7eb3174e&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb3174e"]])

export default __exports__